import Reveal from '@/components/base/Reveal';
import { deepTrack } from '@/mocks/home';

function DeepTrack() {
  return (
    <section id="track" className="w-full bg-background-50 py-20 md:py-28">
      <div className="max-w-shell mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14">
          <Reveal className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <span className="inline-flex items-center gap-2 text-xs tracking-[0.25em] text-secondary-600 font-label">
                <i className="ri-route-line"></i>
                FOLLOW UP
              </span>
              <h2 className="mt-3 font-heading text-3xl md:text-4xl font-bold text-foreground-950">
                深度追踪
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-600">
                一条线索从汇入到成稿，需要经历比对、核实与当事人回应，
                下面是一次完整追踪的时间线。
              </p>

              <div className="mt-8 w-full h-64 md:h-72 rounded-lg overflow-hidden border border-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20wall%20covered%20with%20connected%20documents%2C%20threads%20and%20red%20string%20lines%20on%20an%20investigating%20board%20with%20pinned%20papers%20and%20notes%2C%20warm%20dramatic%20lighting%2C%20editorial%20photography%2C%20charcoal%20and%20amber%20tones%2C%20intense%20mystery%20atmosphere&width=900&height=600&seq=nhbl-track-01&orientation=landscape"
                  alt="深度追踪 - 调查板上用红线连接的资料与线索"
                  title="网红爆料 深度追踪专题"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </Reveal>

          <div className="lg:col-span-7">
            <div className="relative pl-8 md:pl-10">
              <span className="absolute left-[7px] md:left-[9px] top-2 bottom-2 w-px bg-background-300"></span>
              {deepTrack.map((step, index) => (
                <Reveal key={step.date} delay={index * 90}>
                  <div className="relative pb-10 last:pb-0">
                    <span
                      className={`absolute -left-8 md:-left-10 top-1 w-4 h-4 rounded-full border-2 ${
                        index === deepTrack.length - 1
                          ? 'bg-primary-500 border-primary-500'
                          : 'bg-background-50 border-secondary-400'
                      }`}
                    ></span>
                    <p className="text-xs text-primary-700 font-label tracking-wide">{step.date}</p>
                    <h3 className="mt-2 font-heading text-lg md:text-xl font-semibold text-foreground-950">
                      {step.title}
                    </h3>
                    <p className="mt-2.5 text-sm leading-relaxed text-foreground-600 max-w-xl">
                      {step.desc}
                    </p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DeepTrack;